"use client";

import RouteError from "@/components/RouteError";

export default function Error(props: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <RouteError
      {...props}
      boundary="free_kundali_route"
      message="We could not load the kundali calculator. Please try again."
    />
  );
}
